import { AddPhotoAlternate } from "@mui/icons-material";
import { Tooltip, useMediaQuery, useTheme } from "@mui/material";
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  AlignCenterIcon,
  AlignJustifyIcon,
  AlignLeftIcon,
  AlignRightIcon,
  BlockquoteIcon,
  BoldIcon,
  BulletListIcon,
  ItalicIcon,
  OrderedListIcon,
  RedoIcon,
  StrikeThroughIcon,
  UnderlineIcon,
  UndoIcon,
  UnsetMarksIcon,
} from "../../../assets/Icons";
import { setActivePanel } from "../../../redux/slices/panelSlice";
import { dispatch } from "../../../redux/store";
import ImageMenu from "../bubble-menus/image-menu/image-menu";
import InsertUrlBubbleMenu from "../bubble-menus/insert-url-menu/insert-url-bubble-menu";
import SettingsPopover from "../SettingsPopover";
import TablePopover from "../TablePopover";
import { isHeadingZone } from "../Zones/HeadingZones/H2Zone/Extension";
import { ImageUploadModal } from "./components/imageUpload";
import "./Toolbar.css";
import TypographySelect from "./TypographySelect";

const Toolbar = ({ editor }) => {
  const { t } = useTranslation();
  const [currentZone, setCurrentZone] = useState("h1zone");

  const [headingZone, setHeadingZone] = useState("");
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [openEditImage, setOpenEditImage] = useState(false);
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const { values } = useFormikContext();
  const [imageUpload, setImageUpload] = useState(false);
  const [editImageUrl, setEditImageUrl] = useState(false);
  const path =
    values.url_path === ""
      ? "https://mon-site.com/"
      : values.url_path.endsWith("/")
      ? values.url_path
      : values.url_path + "/";
  const urlSlug = values.url_slug === "" ? "slug-url" : values.url_slug;
  const urlSlugValue = `${path}${urlSlug}`;

  const getCurrentZone = (node) => {
    if (!node) return null;
    if (node?.parent?.name === "doc") return node.name;
    return getCurrentZone(node.parent);
  };

  const handleButtonClick = () => {
    // fileInputRef.current.click();
    setImageUpload(true);
  };
  const handleImageModalclose = () => {
    setImageUpload(false);
    setOpenEditImage(false);
  };
  const handleSetImage = (url) => {
    const { state, view } = editor;
    const { selection } = state;

    const isImageSelected = selection.node?.type?.name === "image";

    // Move cursor after selected node if it's an image to avoid replacing
    if (isImageSelected) {
      const posAfter = selection.$to.after();
      editor
        .chain()
        .setTextSelection(posAfter)
        .focus()
        .insertContent({ type: "image", attrs: { src: url } })
        .run();
    } else {
      editor.chain().focus().setImage({ src: url }).run();
    }

    handleImageModalclose();
  };

  useEffect(() => {
    const node = editor.$pos(editor.state.selection.head);
    const zone = getCurrentZone(node);
    const headingZone = isHeadingZone(node)?.name ?? null;
    if (headingZone) {
      setHeadingZone(headingZone);
    } else {
      setHeadingZone("contentzone");
    }
    if (zone) {
      setCurrentZone(zone);
    }
  }, [editor.state.selection.head]);

  // useEffect(() => {
  //   if (!editor) return;

  //   const view = editor.view;
  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       if (!entry.isIntersecting) {
  //         setVisible(false);
  //         document
  //           .querySelectorAll("img.selected-image")
  //           .forEach((img) => img.classList.remove("selected-image"));
  //       }
  //     },
  //     { threshold: 0.1 }
  //   );

  //   const update = () => {
  //     const { state, view } = editor;
  //     const { selection } = state;
  //     const { node, from } = selection;

  //     if (node?.type?.name === "image") {
  //       const dom = view.nodeDOM(from);
  //       if (dom instanceof HTMLElement) {
  //         const rect = dom.getBoundingClientRect();
  //         const imageSrc = node.attrs.src;

  //         setEditImageUrl(imageSrc);
  //         setPosition({
  //           top: rect.top + window.scrollY - 10,
  //           left: rect.left + window.scrollX + rect.width / 2,
  //         });
  //         setVisible(true);

  //         observer.disconnect();
  //         observer.observe(dom);
  //         dom.classList.add("selected-image");
  //       }
  //     } else {
  //       document
  //         .querySelectorAll("img.selected-image")
  //         .forEach((img) => img.classList.remove("selected-image"));
  //       setVisible(false);
  //     }
  //   };

  //   update();

  //   editor.on("selectionUpdate", update);
  //   window.addEventListener("scroll", update, true); // listen to scroll

  //   return () => {
  //     editor.off("selectionUpdate", update);
  //     window.removeEventListener("scroll", update, true);
  //     observer.disconnect();
  //   };
  // }, [editor]);
  // useEffect(() => {
  //   const handleClickOutside = (e) => {
  //     if (editor?.state.selection?.node?.type.name !== "image") {
  //       setVisible(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, [editor]);
  // const handleSetImage = (url) => {
  //   editor.chain().focus().setImage({ src: url }).run();
  //   handleImageModalclose();
  // };

  useEffect(() => {
    const node = editor.$pos(editor.state.selection.head);
    const zone = getCurrentZone(node);
    const headingZone = isHeadingZone(node)?.name ?? null;
    if (headingZone) {
      setHeadingZone(headingZone);
    } else {
      setHeadingZone("contentzone");
    }
    if (zone) {
      setCurrentZone(zone);
    }
  }, [editor.state.selection.head]);

  // useEffect(() => {
  //   if (!editor) return;

  //   const update = () => {
  //     const { state, view } = editor;
  //     const { selection } = state;
  //     const node = selection.node;

  //     // Check if selection is an image
  //     if (selection.node?.type.name === "image") {
  //       const dom = view.nodeDOM(selection.from);
  //       const rect = dom.getBoundingClientRect();
  //       const imageSrc = node.attrs.src;
  //       setEditImageUrl(imageSrc);
  //       setPosition({
  //         top: rect.top + window.scrollY - 10,
  //         left: rect.left + window.scrollX + rect.width / 2,
  //       });
  //       setVisible(true);
  //     } else {
  //       setVisible(false);
  //     }
  //   };
  //   update();
  //   editor.on("selectionUpdate", update);
  //   return () => editor.off("selectionUpdate", update);
  // }, [editor]);
  return (
    <>
      <div className="header-container">
        <SettingsPopover />

        <div
          className="urlslug-wrapper"
          onClick={() => dispatch(setActivePanel("urlSlug"))}
        >
          <input
            className="urlslug-input"
            readOnly
            type="text"
            value={urlSlugValue}
          />
        </div>

        <div className="editor-toolbar-container border-[2px] border-[#e2e8f0]">
          {currentZone === "h1zone" && <div className="toolbar-blocker" />}

          <TypographySelect editor={editor} />

          <Tooltip title={t("bold", "Bold")} arrow>
            <span>
              <button
                onClick={() => editor.chain().focus().toggleBold().run()}
                disabled={!editor.can().chain().focus().toggleBold().run()}
                className={`${
                  editor.isActive("bold") ? "is-active" : ""
                } toolbar-btn`}
              >
                <BoldIcon />
              </button>
            </span>
          </Tooltip>

          <Tooltip title={t("italic", "Italic")} arrow>
            <span>
              <button
                onClick={() => editor.chain().focus().toggleItalic().run()}
                disabled={!editor.can().chain().focus().toggleItalic().run()}
                className={`${
                  editor.isActive("italic") ? "is-active" : ""
                } toolbar-btn`}
              >
                <ItalicIcon />
              </button>
            </span>
          </Tooltip>

          <Tooltip title={t("strikethrough", "Strikethrough")} arrow>
            <span>
              <button
                onClick={() => editor.chain().focus().toggleStrike().run()}
                disabled={!editor.can().chain().focus().toggleStrike().run()}
                className={`${
                  editor.isActive("strike") ? "is-active" : ""
                } toolbar-btn`}
              >
                <StrikeThroughIcon />
              </button>
            </span>
          </Tooltip>

          <Tooltip title={t("underline", "Underline")} arrow>
            <span>
              <button
                onClick={() => editor.chain().focus().toggleUnderline().run()}
                disabled={!editor.can().chain().focus().toggleUnderline().run()}
                className={`${
                  editor.isActive("underline") ? "is-active" : ""
                } toolbar-btn`}
              >
                <UnderlineIcon />
              </button>
            </span>
          </Tooltip>

          <Tooltip title={t("align-left-btn", "Align Left")} arrow>
            <span>
              <button
                onClick={() =>
                  editor.chain().focus().setTextAlign("left").run()
                }
                className={`${
                  editor.isActive({ textAlign: "left" }) ? "is-active" : ""
                } toolbar-btn`}
              >
                <AlignLeftIcon />
              </button>
            </span>
          </Tooltip>

          <Tooltip title={t("align-center-btn", "Align Center")} arrow>
            <span>
              <button
                onClick={() =>
                  editor.chain().focus().setTextAlign("center").run()
                }
                className={`${
                  editor.isActive({ textAlign: "center" }) ? "is-active" : ""
                } toolbar-btn`}
              >
                <AlignCenterIcon />
              </button>
            </span>
          </Tooltip>

          <Tooltip title={t("align-right-btn", "Align Right")} arrow>
            <span>
              <button
                onClick={() =>
                  editor.chain().focus().setTextAlign("right").run()
                }
                className={`${
                  editor.isActive({ textAlign: "right" }) ? "is-active" : ""
                } toolbar-btn`}
              >
                <AlignRightIcon />
              </button>
            </span>
          </Tooltip>

          <Tooltip title={t("justify-btn", "Justify")} arrow>
            <span>
              <button
                onClick={() =>
                  editor.chain().focus().setTextAlign("justify").run()
                }
                className={`${
                  editor.isActive({ textAlign: "justify" }) ? "is-active" : ""
                } toolbar-btn`}
              >
                <AlignJustifyIcon />
              </button>
            </span>
          </Tooltip>

          <Tooltip title={t("clear-formatting", "Clear Formatting")} arrow>
            <span>
              <button
                onClick={() => editor.chain().focus().unsetAllMarks().run()}
                className="toolbar-btn"
              >
                <UnsetMarksIcon />
              </button>
            </span>
          </Tooltip>

          {/* You must modify TablePopover internally to wrap its button in a Tooltip */}
          <TablePopover editor={editor} editorSection="content" />

          <Tooltip title={t("Bullet-list", "Bullet List")} arrow>
            <span>
              <button
                onClick={() => editor.chain().focus().toggleBulletList().run()}
                className={`${
                  editor.isActive("bulletList") ? "is-active" : ""
                } toolbar-btn`}
              >
                <BulletListIcon />
              </button>
            </span>
          </Tooltip>

          <Tooltip title={t("numbered-list", "Numbered List")} arrow>
            <span>
              <button
                onClick={() => editor.chain().focus().toggleOrderedList().run()}
                className={`${
                  editor.isActive("orderedList") ? "is-active" : ""
                } toolbar-btn`}
              >
                <OrderedListIcon />
              </button>
            </span>
          </Tooltip>

          <Tooltip title={t("blockquote", "Blockquote")} arrow>
            <span>
              <button
                onClick={() => editor.chain().focus().toggleBlockquote().run()}
                className={`${
                  editor.isActive("blockquote") ? "is-active" : ""
                } toolbar-btn`}
              >
                <BlockquoteIcon />
              </button>
            </span>
          </Tooltip>

          <Tooltip title={t("image", "Image")} arrow>
            <span>
              <button onClick={handleButtonClick} className="toolbar-btn">
                <AddPhotoAlternate />
              </button>
            </span>
          </Tooltip>

          <Tooltip title={t("undo", "Undo")} arrow>
            <span>
              <button
                onClick={() => editor.chain().focus().undo().run()}
                disabled={!editor.can().chain().focus().undo().run()}
                className="toolbar-btn"
              >
                <UndoIcon />
              </button>
            </span>
          </Tooltip>

          <Tooltip title={t("redo", "Redo")} arrow>
            <span>
              <button
                onClick={() => editor.chain().focus().redo().run()}
                disabled={!editor.can().chain().focus().redo().run()}
                className="toolbar-btn"
              >
                <RedoIcon />
              </button>
            </span>
          </Tooltip>

          {/* You must modify InsertUrlBubbleMenu internally to wrap its button in a Tooltip */}
          <InsertUrlBubbleMenu editor={editor} />
        </div>
      </div>
      {/* {visible && (
        <div
          className="floating-toolbar"
          style={{
            top: position.top,
            left: position.left,
          }}
        >
          <button onClick={() => setOpenEditImage(true)}>
            <Edit />
          </button>
          <button onClick={() => editor.commands.deleteSelection()}>
            <HighlightOff />
          </button>
        </div>
      )} */}
      <ImageMenu
        editor={editor}
        editImage={(img) => {
          setOpenEditImage(true);
          setEditImageUrl(img);
        }}
      />
      {(imageUpload || openEditImage) && (
        <ImageUploadModal
          formikValues={values}
          handleImageModal={handleImageModalclose}
          handleSetImage={handleSetImage}
          editor={editor}
          isEdit={openEditImage}
          editImageUrl={editImageUrl}
        ></ImageUploadModal>
      )}
    </>
  );
};

export default Toolbar;
